<template>
    <section class="blog-sec">
        <div class="blog-sec-container">
            <div class="blog-sec-header">
                <h2>مقالات آموزشی</h2>
                <router-link to="/blog">بیشتر</router-link>
            </div>

            <!-- loading... -->
            <p v-if="isPostsLoading" class="loading"> در حال بارگذاری ... </p>

            <!-- error -->
            <div v-if="postsError" class="error">
                <p>خطا در دریافت مقالات .</p>
                <button @click="getLastPosts">تلاش مجدد</button>
            </div>

            <swiper v-else class="blog-sec-swiper" :modules="modules" slidesPerView="auto" :loop="lastPosts.length > 3" :autoplay="{
                delay: 2000,
                disableOnInteraction: false,
            }" :allow-touch-move="true" :breakpoints="{
                0: {
                    spaceBetween: 20,
                },
                1440: {
                    spaceBetween: 41,
                }
            }">
                <swiper-slide v-for="blog in lastPosts" :key="blog.p">
                    <BlogItem :blog="blog" />
                </swiper-slide>
            </swiper>
        </div>
    </section>
</template>

<script>
import BlogItem from './BlogItem.vue';
import axios from 'axios';
import { ref, onMounted } from "vue";
import { Autoplay } from 'swiper/modules';
export default {
    name: "HomeSection8",
    components: {
        BlogItem
    },
    setup() {
        const isPostsLoading = ref(true);
        const postsError = ref(false);
        const lastPosts = ref([]);

        function getLastPosts(){
            isPostsLoading.value = true;
            postsError.value = false;
            axios({
                method: 'POST',
                url: `${process.env.VUE_APP_ONCLICK_API_DOMAIN}/blog`,
                data: {
                    "rowCount": 4,
                    "hasPagination": false,
                }
            }).then(response => {
                lastPosts.value = response.data.p;
                isPostsLoading.value = false;
                }).catch(err => {
                    console.error('خطا در دریافت اطلاعات:', err);
                    isPostsLoading.value = false;
                    postsError.value = true;
            });
        }

        onMounted(() => {
            getLastPosts();
        });

        return {
            modules: [Autoplay],
            lastPosts,
            postsError,
            getLastPosts,
            isPostsLoading,
        };
    },
}
</script>

<style scoped>
.blog-sec {
    width: 100%;
    height: 674px;
    background-color: rgba(231, 231, 231, 0.2);
}

.blog-sec-container {
    padding: 5.209% 15%;
}

.blog-sec-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px;
    margin-bottom: 3.125%;
}

.blog-sec-header h2 {
    font-size: 24px;
}

.blog-sec-header a {
    color: var(--main-pink);
}

.blog-sec-swiper {
    width: 100%;
    user-select: none;
    padding: 10px;
}

.swiper-slide {
    width: auto;
}

@media screen and (min-width: 1921px) {
    .blog-sec-container {
        width: 1344px;
        margin-inline: auto;
        padding: 100px 0;
    }
}

@media screen and (max-width: 1440px) {
    .blog-sec {
        height: 617px;
    }

    .blog-sec-header h2 {
        font-size: 22px;
    }
}

@media screen and (max-width: 1024px) {
    .blog-sec {
        height: 569px;
    }

    .blog-sec-container {
        padding-inline: 5.556%;
    }

    .blog-sec-header h2 {
        font-size: 20px;
    }
}

@media screen and (max-width: 768px) {
    .blog-sec {
        height: 508px;
    }

    .blog-sec-header h2 {
        font-size: 18px;
    }

    .blog-sec-header a {
        font-size: 16px;
    }
}

@media screen and (max-width: 360px) {
    .blog-sec {
        height: 426px;
    }

    .blog-sec-header {
        padding: 12px;
    }

    .blog-sec-header h2 {
        font-size: 16px;
    }

    .blog-sec-header a {
        font-size: 14px;
    }
}
</style>